import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../../imagenes/logo/logo-nuevo.png'
import logo2x from '../../imagenes/logo/logo-nuevo.png'
import logo3x from '../../imagenes/logo/logo-nuevo.png'
//import logoNavidad from '../../imagenes/logo/logo-web-navidad.png'
//import logoNavidadx2 from '../../imagenes/logo/logo-web-navidad@2x.jpg'
//import logoNavidadx3 from '../../imagenes/logo/logo-web-navidad@3x.jpg'
import RedesSociales from './RedesSociales'
// import Suscribite from './Suscribite'


class Footer extends React.Component {

    render() {

        return (
                <footer>
                  {/* <Suscribite /> */}
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-12 logo">
                      <Link to='/'>
                        <img src={logo} alt="Logo de Pedraza Viajes. Al clickearlo, volveremos a la pantalla de inicio"  />
                      </Link>
                      </div>
                      <div className="col-xl-7 col-lg-7 col-md-5 col-sm-8 col-12 nav">
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                          <ul>
                            <li>
                              <h6>Legales</h6>
                            </li>
                            <li>
                              <Link to='/terminos-y-condiciones'>Condiciones de contrataci&oacute;n</Link>
                            </li>
                            <li>
                              <a href="https://www.argentina.gob.ar/interior/migraciones/entrada-y-salida-del-pais" target="_blank" rel="noopener noreferrer">Documentaci&oacute;n</a>
                            </li>
                            <li>
                              <a href="https://www.argentina.gob.ar/viajar-con-menores-de-edad-en-micros-de-larga-distancia" target="_blank" rel="noopener noreferrer">Traslado Menores</a>
                            </li>
                            {/*<li>
                                <Link to='/reserva-flexible'>Reserva Flexible</Link>
                            </li>*/}
                            <li>
                              <a href="https://pedraza.com.ar/botonArrepentido">Arrepentimiento de Compra</a>
                            </li>

                          </ul>
                        </div>

                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                          <ul>
                            <li>
                              <h6>informaci&oacute;n</h6>
                            </li>
                            <li>
                              <Link to='/faqs'>Preguntas frecuentes</Link>
                            </li>
                            {/*<li>
                              <a href="https://www.mercadopago.com.ar/cuotas" target="_blank" rel="noopener noreferrer">Mercado Pago</a>
                            </li>
                            <li>
                              <Link to="/promociones-bancarias" >Promociones Bancarias</Link>
                            </li>
                            */}
                            <li>
                              <Link to='/formas-de-pago'>Formas de pago</Link>
                            </li>
                            <li>
                              <Link to='/coberturaDeSalud'>Cobertura de Salud</Link>
                            </li>
                            {/*<li>
                              <Link to='/programaPreventa'>Condiciones Previaje 5</Link>
                            </li>*/}
                          </ul>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                          <ul>
                            <li>
                              <h6>Pedraza Viajes</h6>
                            </li>
                            <li>
                              <Link to='/empresa'>La empresa</Link>
                            </li>
                            <li>
                              <Link to='/sucursales'>Sucursales</Link>
                            </li>
                            <li>
                              <Link to='/trabajaConNosotros'>Trabaj&aacute; con nosotros</Link>
                            </li>
                            <li>
                              <Link to='/contacto'>Contacto</Link>
                            </li>
                            <li>
                              <a href='http://pedraza.com.ar/encuesta/' target="_blank" rel="noopener noreferrer">Encuesta</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12 social-networks">
                        <RedesSociales />
                      </div>
                    </div>
                    </div>
                </footer>
                );
    }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Global/Footer.js